import { Button, cn } from '@buakei/ui';
import { Link, NavLink, Outlet } from 'react-router';
import { useAuth } from '@/auth/session';
import { Brand } from '@/shell/Brand';
import { EXPERIENCE_META } from '@/shell/nav-config';

export function PublicLayout() {
  const { session, accounts } = useAuth();
  const home = session?.experiences[0];
  const link = ({ isActive }: { isActive: boolean }) =>
    cn(
      'rounded-md px-3 py-2 text-sm font-medium text-navy-900 hover:bg-navy-50',
      isActive && 'font-semibold underline decoration-2 underline-offset-8',
    );

  return (
    <div className="flex min-h-dvh flex-col">
      <header className="border-b border-line-200 bg-white">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center gap-3 px-4 py-3">
          <Link to="/" className="rounded-md">
            <Brand size="sm" />
            <span className="sr-only"> home</span>
          </Link>
          <nav
            aria-label="Site"
            className="order-3 flex w-full gap-1 overflow-x-auto sm:order-none sm:ml-6 sm:w-auto"
          >
            <NavLink to="/" end className={link}>
              Home
            </NavLink>
            <NavLink to="/pricing" className={link}>
              Pricing
            </NavLink>
            <NavLink to="/security" className={link}>
              Security
            </NavLink>
          </nav>
          <div className="ml-auto">
            {session && home ? (
              <Button asChild size="sm">
                <Link to={EXPERIENCE_META[home].home}>Open workspace</Link>
              </Button>
            ) : session ? (
              <Button asChild size="sm">
                <Link to="/account">Your account</Link>
              </Button>
            ) : (
              <Button asChild size="sm">
                <Link to="/sign-in">{accounts ? 'Sign in' : 'Try the demo'}</Link>
              </Button>
            )}
          </div>
        </div>
      </header>
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <footer className="on-navy border-t border-white/10 bg-navy-950 text-white">
        <div className="mx-auto flex max-w-6xl flex-col gap-3 px-4 py-8 text-sm">
          <Link to="/" className="self-start rounded-md">
            <Brand tone="white" size="sm" />
            <span className="sr-only"> home</span>
          </Link>
          <p className="max-w-3xl text-white/90">
            Buakei AI is in early development. It does not provide legal advice, and legal research
            is not yet live.
          </p>
        </div>
      </footer>
    </div>
  );
}
